import Card from '@perpay-web/components/base/Card/Card';
import CustomButton from '@perpay-web/components/base/CustomButton/CustomButton';
import Modal from '@perpay-web/components/base/Modal/Modal';
import CardCta from '@perpay-web/fintech/components/base/CardCta/CardCta';
import CustomLink from '@perpay-web/fintech/components/base/CustomLink/CustomLink';
import { AUTOMATIC_TRANSFERS_AGREEMENT_URL } from '@perpay-web/fintech/constants/urls';
import { getClassName } from '@perpay-web/utils/domUtils';

import styles from './CardAutoTransferDisagreementVerification.scss';

const CardAutoTransferDisagreementVerification = ({
    onSubmit = null,
    isSubmitting,
    onClickTransfersAgreement = null,
    checked = false,
    onChange = null,
    onClose = null,
}) => (
    <Modal
        showClose
        className={styles.modal}
        onClose={onClose}
        containerClassName={styles['modal-container']}
    >
        <div className={styles.title}>
            Are you sure you want to continue without automatic transfers?
        </div>
        <div className={styles['modal-copy']}>
            With automatic transfers enabled, your direct deposit effortlessly
            applies to your card balance which helps build your credit.
        </div>
        <Card className={styles['modal-items']}>
            <div className={styles['item-header']}>
                <div
                    className={getClassName(
                        styles['recurring-icon--money-flower'],
                        styles['recurring-icon'],
                    )}
                />{' '}
                Stress Free Payments
            </div>
            <div className={styles['item-header']}>
                <div
                    className={getClassName(
                        styles['recurring-icon--graph'],
                        styles['recurring-icon'],
                    )}
                />{' '}
                Credit building simplified
            </div>
        </Card>
        <Card className={styles['checkbox-container']}>
            <label
                className={styles.terms__content}
                htmlFor='reverifyAutoTransferAgreement'
                aria-label='accept automatic transfers agreement'
            >
                <input
                    id='reverifyAutoTransferAgreement'
                    className={styles.checkbox}
                    type='checkbox'
                    name='optedInToAutoApply'
                    checked={checked}
                    onChange={onChange}
                />
                <div className={styles['checkbox-image']}>
                    <div className={styles['checkbox-icon']} />
                </div>
                <div className={styles['checkbox-text']}>
                    <div className={styles['checkbox-text-section']}>
                        By checking this box, I agree to the{' '}
                        <CustomLink
                            onClick={onClickTransfersAgreement}
                            href={AUTOMATIC_TRANSFERS_AGREEMENT_URL}
                            target='_blank'
                        >
                            Perpay Automatic Transfers Agreement
                        </CustomLink>
                        .
                    </div>
                </div>
            </label>
        </Card>
        <div>
            <CardCta
                Component={CustomButton}
                className={styles['discard-button']}
                mode='dark'
                loading={isSubmitting}
                onClick={onSubmit}
                type='button'
            >
                Continue
            </CardCta>
        </div>
    </Modal>
);

export default CardAutoTransferDisagreementVerification;
